import { guardEmptyArray, guardUnspecified } from '@portal/utils/util-guards';
import { componentFactory } from 'vue-tsx-support';

import { JtnUiRecordTags } from '@jtn-ui/components/record';
import { ObserverVisibility, tsStoreMixin } from '@jtnews/shared';

type Tag = {
  name: string;
  url?: string;
};

type ComponentData = {
  obsHalfTagsOptions: ObserverVisibility;
};

export default componentFactory.mixin(tsStoreMixin).create({
  name: 'RecordTags',
  props: {
    tags: {
      type: Array as () => Tag[]
    }
  },
  data(): ComponentData {
    return {
      obsHalfTagsOptions: new ObserverVisibility('half')
    };
  },
  computed: {
    hasTags(): boolean {
      return guardUnspecified(this.tags) && guardEmptyArray(this.tags);
    }
  },
  mounted() {
    if (guardUnspecified(this.$refs.tags)) {
      (this.$refs.tags as Vue).$el.addEventListener('scroll', this.swipeTags, {
        once: true
      });
    }

    this.obsHalfTagsOptions.event.subscribe(({ value }) => {
      if (value) {
        this.sendNewReachGoal('Просмотр', 'viewTags');
      }
    });
  },
  beforeDestroy() {
    if (guardUnspecified(this.$refs.tags)) {
      (this.$refs.tags as Vue).$el.removeEventListener('scroll', this.swipeTags);
    }
  },
  methods: {
    sendNewReachGoal(valueName: string | Record<string, string>, goalName: string) {
      this.store.analyticsModule.sendNewReachGoal({
        blockType: 'Центральная колонка',
        fieldType: 'Теги',
        valueName,
        goalName
      });
    },
    sendNewFormatReachGoal(
      goalName: string,
      blockType: string,
      actionType: string,
      prop1?: string,
      prop2?: string
    ) {
      this.store.analyticsModule.sendNewFormatReachGoal({
        goalName,
        blockType,
        actionType,
        prop1,
        prop2
      });
    },
    sendTagClickedRG(name: string) {
      this.sendNewReachGoal({ Переход: name }, 'clickTags');
      this.sendNewFormatReachGoal('ClickArticleFooter', 'Тег', 'Клик', name);
    },
    swipeTags() {
      (this.$refs.tags as Vue).$el.removeEventListener('scroll', this.swipeTags);
      this.sendNewReachGoal('Свайп', 'swypeTags');
    }
  },
  render() {
    return (
      <div v-observe-visibility={this.obsHalfTagsOptions.getOptions('half')}>
        {this.hasTags && (
          <JtnUiRecordTags
            ref="tags"
            tags={this.tags}
            onTagClicked={({ name }) => this.sendTagClickedRG(name)}
          />
        )}
      </div>
    );
  }
});
